import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AuthenticMexicanFlavors() {
  const {
    ref: heroRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="authentic-mexican-flavors" className="relative w-full overflow-hidden bg-background py-16 lg:py-24" ref={heroRef}>
      {}
      <div className="absolute inset-0 z-0 opacity-40 pointer-events-none mix-blend-multiply bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/stucco_texture_overlay.png)] bg-repeat" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 lg:items-center">
          
          {}
          <div className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <h1 className="font-serif text-5xl font-bold leading-[1.1] tracking-tight text-secondary sm:text-6xl md:text-7xl lg:text-8xl">Comida
Mexicana Autentica
Para Sus Momentos
Mas Especiales</h1>
            
            <p className="max-w-[600px] text-lg text-muted-foreground md:text-xl font-sans leading-relaxed">Banquetes Orzuna te trae el sabor de las fiestas familiares y deliciosos platillos de México a tus celebraciones en Indianápolis.</p>

            <div className="flex flex-col w-full sm:w-auto sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300">
                <Link to="https://form.jotform.com/260726417957063" newTab>Reserva Tu Evento Aqui </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`relative mt-10 lg:mt-0 h-[500px] md:h-[600px] w-full transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] md:w-[450px] md:h-[450px] bg-[var(--chart-3)] rounded-full opacity-20 blur-3xl -z-10" />

            {}
            <div className="absolute top-10 left-0 md:left-4 w-3/5 md:w-[55%] aspect-[4/5] z-20 transform hover:scale-[1.02] transition-transform duration-500">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/15.png" alt="Rich and savory Birria platter ready for serving" className="h-full w-full object-cover rounded-2xl shadow-2xl border-4 border-white/50" />
            </div>

            {}
            <div className="absolute top-0 right-0 md:right-8 w-2/5 md:w-[40%] aspect-square z-10 transform hover:scale-[1.02] transition-transform duration-500">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/2-1.png" alt="Family celebrating with a toast" className="h-full w-full object-cover rounded-2xl shadow-xl border-4 border-white/50" />
            </div>

            {}
            <div className="absolute bottom-8 right-4 md:right-12 w-1/2 md:w-[45%] aspect-[4/3] z-30 transform hover:scale-[1.02] transition-transform duration-500">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/3.png" alt="Close up of fresh authentic Mexican salsa" className="h-full w-full object-cover rounded-2xl shadow-2xl border-4 border-white/50" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}